import {createSelector} from 'reselect';
import {getSelectedDeliveryOptionIDList} from '../../DeliveryOptionsSelectors/DeliveryOptionsSelectors';

const makeIsPaymentOptionHiddenByDeliveryOption = paymentType => createSelector(
  [getSelectedDeliveryOptionIDList],
  (deliveryOptionIdList) => {
    if (paymentType !== 'PAY_ON_DELIVERY') return deliveryOptionIdList.includes(73);

    return paymentType !== 'PAY_ON_DELIVERY' ? deliveryOptionIdList.includes(73) : false;
  },
);

export default makeIsPaymentOptionHiddenByDeliveryOption;
